@if (isScreenTooSmall()) {
    <app-screen-too-small
        [titleText]="'general.screen-too-small.title' | translate"
        [descriptionText]="'general.screen-too-small.description' | translate"
    />
}
<div class="page-wrapper h-full">
    <app-skip-link targetId="main-content" [label]="'general.bypass-link.skip-to-content' | translate" />
    <app-skip-link targetId="footer" [label]="'general.bypass-link.skip-to-footer' | translate" />
    <app-shared-header
        [appName]="'header.appName' | translate"
        [homeAriaLabel]="'header.app-name-homepage' | translate"
        [selectedLang]="selectedLang()"
        [user]="user()"
        [profilePicture]="picture()"
        [allowProfilePicture]="allowProfilePicture() ?? false"
        [hideUserControls]="isScreenTooSmall()"
        (languageChanged)="changeLanguage($event)"
    />
    <div class="content-wrapper grow w-full px-2 sm:px-2 md:px-4 lg:px-8">
        <router-outlet />
    </div>
    <app-shared-footer id="footer" />
</div>
